import { HAS_MEDIA_FILTER_ID, HAS_MEDIA_FILTER_TITLE } from '../../constants';
import { createCheckboxFilter } from './createCheckboxFilter';

export const createHasMediaFilter = () =>
    createCheckboxFilter({
        id: HAS_MEDIA_FILTER_ID,
        title: HAS_MEDIA_FILTER_TITLE,
    });
